import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureaddSupport, successaddSupport } from "./AddSupportSlice";
import { Isupport } from "../../../Pages/Setting/ISetting";

// add
const AddSupportApi = (action: PayloadAction<Isupport>) => {
  return api.post("/api/support/", action.payload);
};

export function* AddSupportCall(action: PayloadAction<Isupport>) {
  try {
    const response: AxiosResponse = yield call(AddSupportApi, action);
    yield put(successaddSupport(response.data));
  } catch (error) {
    yield put(failureaddSupport(error));
  }
}
